export default "__VITE_ASSET__lZ7J0aDc__"